import { Wallet } from 'lucide-react';
import type { FeatureModule } from '../../app/feature-module';
import { FinanceiroPage } from './pages/FinanceiroPage';
import { ImportarExtratoReviewPage } from './pages/ImportarExtratoReviewPage';
import { ImportacoesListPage } from './pages/ImportacoesListPage';
import { FaturasListPage } from './pages/FaturasListPage';
import { FaturaReviewPage } from './pages/FaturaReviewPage';
import { DrePage } from './pages/DrePage';
import { AccountantReportPage } from './pages/AccountantReportPage';

export const financeiroModule: FeatureModule = {
  id: 'financeiro',
  label: 'Financeiro',
  icon: Wallet,
  basePath: '/financeiro',
  routes: [
    { path: '/', element: <FinanceiroPage /> },
    { path: '/importacoes', element: <ImportacoesListPage /> },
    { path: '/importacoes/:id', element: <ImportarExtratoReviewPage /> },
    { path: '/faturas', element: <FaturasListPage /> },
    { path: '/faturas/:id', element: <FaturaReviewPage /> },
    { path: '/dre/:closingId', element: <DrePage /> },
    { path: '/relatorio-contador', element: <AccountantReportPage /> },
    { path: '/relatorio-contador/:closingId', element: <AccountantReportPage /> },
  ],
  sidebarSection: 'workspace',
  requiredPermission: 'financial.read',
};
